// Megamenu „Produkty” na desktopie: aktywna kategoria główna (.t0.is-active) przełączana z menu-aim —
// ruch kursora w stronę panelu nie zmienia kategorii, ruch w pionie zmienia ją od razu. Grafiki
// podkategorii i prawa kolumna (produkt albo baner z /megamenu_side) pobierane przy pierwszej aktywacji.
const AIM_DELAY = 300;
const AIM_TOLERANCE = 30;
const SIDE_REVEAL_TIMEOUT = 1500;

export default function () {
    const treeTop = document.getElementById('tree-top');
    const tree = document.getElementById('tree');
    const list = tree && tree.querySelector(':scope > nav > ul');
    if (!treeTop || !list) return;

    const mq = window.matchMedia('(min-width: 1280px)');
    const rows = [...list.children].filter(li => li.classList.contains('t0') && !li.classList.contains('producers-menu'));
    const locations = [];
    let active = null;
    let timer = 0;
    let lastDelayLocation = null;

    tree.classList.add('aim-ready');

    function wake() {
        if (!mq.matches) return;
        treeTop.classList.add('was-hovered');
        if (!active) activate(rows.find(li => li.classList.contains('parent')) || rows[0]);
    }

    treeTop.addEventListener('mouseenter', wake);
    treeTop.addEventListener('focusin', e => {
        if (e.target.matches(':focus-visible')) wake();
    });

    tree.addEventListener('mousemove', e => {
        locations.push({ x: e.clientX, y: e.clientY });
        if (locations.length > 3) locations.shift();
    });

    tree.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        locations.length = 0;
    });

    rows.forEach(li => {
        li.addEventListener('mouseenter', () => {
            if (!mq.matches) return;
            clearTimeout(timer);
            possiblyActivate(li);
        });

        const link = li.querySelector(':scope > a');
        if (link) {
            link.addEventListener('focus', () => {
                if (mq.matches) activate(li);
            });
        }
    });

    function possiblyActivate(li) {
        const delay = activationDelay();
        if (delay) {
            timer = setTimeout(() => possiblyActivate(li), delay);
        } else {
            activate(li);
        }
    }

    // jQuery-menu-aim: kursor zmierza do panelu, gdy względem poprzedniej pozycji „otwiera” się
    // trójkąt między nim a górnym i dolnym rogiem lewej krawędzi panelu
    function activationDelay() {
        if (!active) return 0;

        const location = locations[locations.length - 1];
        const previous = locations[0];
        if (!location || !previous) return 0;

        const listRect = list.getBoundingClientRect();
        const treeRect = tree.getBoundingClientRect();
        const panelLeft = listRect.right;
        if (location.x >= panelLeft || previous.x >= panelLeft) return 0;
        if (lastDelayLocation && location.x === lastDelayLocation.x && location.y === lastDelayLocation.y) return 0;

        const upper = { x: panelLeft, y: treeRect.top - AIM_TOLERANCE };
        const lower = { x: panelLeft, y: treeRect.bottom + AIM_TOLERANCE };
        const slope = (a, b) => (b.y - a.y) / (b.x - a.x);

        if (slope(location, upper) < slope(previous, upper) && slope(location, lower) > slope(previous, lower)) {
            lastDelayLocation = location;
            return AIM_DELAY;
        }

        lastDelayLocation = null;
        return 0;
    }

    function activate(li) {
        if (!li || li === active) return;
        if (active) active.classList.remove('is-active');

        active = li;
        li.classList.add('is-active');
        loadImages(li);
        loadSide(li);
    }

    function loadImages(li) {
        if (li.dataset.imagesRequested) return;
        li.dataset.imagesRequested = 'true';

        const icon = li.querySelector(':scope > .menu-cat-icon img');
        const fallback = icon ? icon.getAttribute('src') : null;

        li.querySelectorAll(':scope > ul > .t1 > .subcategory-image, :scope > .tree-feature .feature-image').forEach(figure => {
            const img = figure.querySelector('img');
            if (!img) return;

            const showFallback = () => {
                figure.classList.add('is-fallback');
                if (fallback && img.getAttribute('src') !== fallback) {
                    img.src = fallback;
                } else {
                    figure.classList.add('is-loaded');
                }
            };

            img.addEventListener('load', () => figure.classList.add('is-loaded'));
            img.addEventListener('error', showFallback);

            if (img.dataset.categorySrc) {
                img.src = img.dataset.categorySrc;
            } else {
                showFallback();
            }
        });
    }

    function loadSide(li) {
        const side = li.querySelector(':scope > ul > .side-column');
        if (!side || side.dataset.state) return;
        side.dataset.state = 'loading';

        fetch(`/megamenu_side?id=${encodeURIComponent(side.dataset.sideId)}`, { credentials: 'same-origin' })
            .then(response => {
                if (!response.ok) throw new Error(response.status);
                return response.status === 204 ? '' : response.text();
            })
            .then(html => {
                if (!html.trim()) throw new Error('empty');

                side.innerHTML = html;
                if (window.lazyLoadInstance) window.lazyLoadInstance.update();
                reveal(side);
            })
            .catch(() => {
                side.dataset.state = 'empty';
                side.classList.add('is-empty');
            });
    }

    function reveal(side) {
        let shown = false;
        const show = () => {
            if (shown) return;
            shown = true;
            side.dataset.state = 'loaded';
            side.classList.add('is-loaded');
        };

        const img = side.querySelector('img');
        if (!img || (img.complete && img.naturalWidth)) {
            show();
            return;
        }

        img.addEventListener('load', show, { once: true });
        img.addEventListener('error', show, { once: true });
        setTimeout(show, SIDE_REVEAL_TIMEOUT);
    }
}
